import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w100 OneMessageContent"
}
const _hoisted_2 = {
  key: 0,
  class: "w100 pad5 centered",
  style: {"padding":"5px 35px"}
}
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"centered\"><hr class=\"w30 fl\" style=\"border-top:1px solid #ff2c2c;margin-top:10px;margin-bottom:10px;\"><p class=\"redColor fl fs12 w40\" style=\"margin-top:2px;\">ここから未読のメッセージ</p><hr class=\"w30 fl\" style=\"border-top:1px solid #ff2c2c;margin-top:10px;margin-bottom:10px;\"></div><div class=\"clear\"></div>", 2)
const _hoisted_5 = [
  _hoisted_3
]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "w100 pad10" }
const _hoisted_8 = { class: "fs10 centered" }
const _hoisted_9 = {
  class: "w80 lgreyBg pad10 fs12 kaigyo",
  style: {"margin-left":"10%","border-radius":"14px","text-align":"center","line-height":"18px"}
}
const _hoisted_10 = {
  key: 2,
  class: "pad15"
}
const _hoisted_11 = {
  key: 0,
  class: "fs10 centered",
  style: {"margin-bottom":"10px"}
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_13 = {
  key: 1,
  class: "fl"
}
const _hoisted_14 = {
  key: 2,
  class: "fl fs13"
}
const _hoisted_15 = {
  key: 0,
  class: "fw400"
}
const _hoisted_16 = { class: "fw600" }
const _hoisted_17 = { class: "fs11 grey" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_20 = {
  key: 3,
  class: "fs11 grey fr"
}
const _hoisted_21 = { class: "fs11 dgrey" }
const _hoisted_22 = ["src"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", null, "うまく送信できませんでした。", -1)
const _hoisted_24 = ["src"]
const _hoisted_25 = {
  key: 4,
  class: "fs11 grey fr",
  style: {"margin-top":"3px"}
}
const _hoisted_26 = { key: 0 }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserIcon = _resolveComponent("UserIcon")!
  const _component_OneMessageInnerContent = _resolveComponent("OneMessageInnerContent")!
  const _component_MdProgressSpinner = _resolveComponent("MdProgressSpinner")!
  const _component_UserFileImage = _resolveComponent("UserFileImage")!

  return (_ctx.message)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.firstUnread)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_5))
          : _createCommentVNode("", true),
        (_ctx.message.is_system)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.createdTime), 1),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.message.message), 1)
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_10, [
              (_ctx.message.start_of_the_day)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.createdDate), 1))
                : _createCommentVNode("", true),
              _hoisted_12,
              (!_ctx.isMe && _ctx.message.id != `unsent`)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createVNode(_component_UserIcon, {
                      width: 36,
                      canEdit: false,
                      member: _ctx.currentMem || this.message.owner,
                      class: "fl fw600 fs20 pointer mr10",
                      showTooltip: true
                    }, null, 8, ["member"])
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_OneMessageInnerContent, {
                message: _ctx.message,
                isMe: _ctx.isMe
              }, null, 8, ["message", "isMe"]),
              false
                ? (_openBlock(), _createElementBlock("p", _hoisted_14, [
                    (_ctx.memberCompanyName)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.memberCompanyName), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.memberName), 1),
                    _createElementVNode("span", _hoisted_17, "  " + _toDisplayString(_ctx.createdTime), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: _normalizeClass(`${_ctx.isMe ? `fr` : `fl`} fs11`),
                style: {"margin":"0 6px"}
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass(`${_ctx.isMe ? `fr` : `fl`} fs11 grey`)
                }, _toDisplayString(_ctx.createdTime), 3),
                _hoisted_18,
                _createElementVNode("span", {
                  class: _normalizeClass(`${_ctx.isMe ? `fr` : `fl`} fs11 grey`)
                }, "既読 " + _toDisplayString(_ctx.readCount) + " / " + _toDisplayString(_ctx.memberNum), 3)
              ], 2),
              _hoisted_19,
              (_ctx.message.id == `unsent`)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    _createElementVNode("span", _hoisted_21, [
                      _createTextVNode("    "),
                      _createElementVNode("img", {
                        src: _ctx.$getAssetImageUrl(`/assets/icons/bikkuri.png`),
                        width: "18",
                        height: "18",
                        style: {"margin-top":"-2px"}
                      }, null, 8, _hoisted_22),
                      _hoisted_23
                    ]),
                    _createElementVNode("img", {
                      src: _ctx.$getAssetImageUrl(`/assets/icons/refresh.png`),
                      width: "18",
                      height: "18",
                      class: "pointer",
                      style: {"margin-top":"-2px","margin-right":"8px"},
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.resend(_ctx.message)))
                    }, null, 8, _hoisted_24)
                  ]))
                : (_ctx.message.id == `sending`)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      _createVNode(_component_MdProgressSpinner, { width: `12` })
                    ]))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 5,
                      class: _normalizeClass(`${_ctx.isMe ? `fr` : `fl`} fs11 mt10`)
                    }, [
                      (_ctx.userFiles && _ctx.userFiles.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userFiles, (file, fileindex) => {
                              return (_openBlock(), _createBlock(_component_UserFileImage, {
                                key: fileindex,
                                file: file,
                                showDeleteButton: file.can_delete,
                                type: `wide`,
                                isMe: _ctx.isMe,
                                onDeleted: _ctx.deletedAttachment,
                                onShowPreview: _ctx.showPreview
                              }, null, 8, ["file", "showDeleteButton", "isMe", "onDeleted", "onShowPreview"]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ], 2)),
              _hoisted_27
            ]))
      ]))
    : _createCommentVNode("", true)
}